<template>
  <div class="card " style="height: fit-content;width: 100%;">
    <div class="card w-100 h-100" style="background-color: #edeaf2">
      <div class="d-flex w-100 h-100 py-2 " >
        <div style="width: 20% ; height: 100%" class="d-flex align-items-center ">
          <p class="font-weight-boldest ml-5" style="margin-bottom: 0; font-size: 13px">{{label}}</p>
        </div>
        <div style="width: 30%;" class="d-flex  h-100">
          <div class="w-100 px-4">
            <el-select
                v-model="markValue.valueOption"
                :placeholder="placeholder"
                :disabled="true"
            >
              <el-option
                  v-for="item in optionScoreSpeaking"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="d-flex  " style="width: 50%;">
          <div class="w-100 px-4">
            <el-input
              type="textarea"
              placeholder="Nhập nhận xét"
              v-model="markValue.comment"
              style="width: 100%"
              :disabled="true"
              :rows="3"
              resize="none">
            </el-input>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {optionScoreSpeaking, optionScoreSpeaking9} from "@/core/option/selectScore";

export default {
  name: "SelectOption",
  data() {
    return {
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    markValue: {
      type: Object,
      default: {
        valueOption: 0,
        comment: ''
      }
    },
    placeholder: {
      type: String,
      default: ''
    },
    typeMark:{
      type: Number,
      default: '',
    },
    readOnly: {
      type: Boolean,
      default: false,
    }
  },
  computed:{
    optionScoreSpeaking(){
      return this.typeMark === 10 ?optionScoreSpeaking : optionScoreSpeaking9
    }
  }
}
</script>

<style lang="scss" scoped>

</style>